import { UpsellPageTimer } from "@redotech/redo-conversion-core-common/upsell-page/upsell-page-db-validator";
import {
  BannerStatus,
  TextAppearance,
} from "@redotech/redo-conversion-core-common/upsell-page/upsell-page-types";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import {
  BgColorValue,
  BorderColorValue,
  SpacingValue,
} from "@redotech/redo-web/theme/box";
import { TextColorValue } from "@redotech/redo-web/theme/typography";
import { assertNever } from "@redotech/util/type";
import { bannerTextSize } from "./post-purchase-banner";

const timerBackgroundColor = (
  status: BannerStatus,
): { background: BgColorValue; border: BorderColorValue } => {
  switch (status) {
    case BannerStatus.INFO:
      return { background: "brand-primary", border: "brand" };
    case BannerStatus.SUCCESS:
      return { background: "success-primary", border: "primary" };
    case BannerStatus.CRITICAL:
      return { background: "error-primary", border: "error-solid" };
    case BannerStatus.WARNING:
      return { background: "warning-primary", border: "error-solid" };
    default:
      assertNever(status);
  }
};

const timerTextColor = (appearance: TextAppearance): TextColorValue => {
  switch (appearance) {
    case TextAppearance.SUCCESS:
      return "success";
    case TextAppearance.CRITICAL:
      return "error";
    case TextAppearance.WARNING:
      return "warning";
    default:
      assertNever(appearance);
  }
};

export const PostPurchaseTimer = function PostPurchaseTimer({
  timer,
  px = "none",
}: {
  timer: UpsellPageTimer;
  px?: SpacingValue;
}) {
  if (!timer.showTimer) {
    return null;
  }

  const timerBackgroundColorValue = timerBackgroundColor(
    timer.timerBannerStatus,
  );
  const timerTextColorValue = timerTextColor(timer.timerTextColor);
  const timerTextSizeValue = bannerTextSize(timer.timerTextSize);
  const supportingTextSizeValue = bannerTextSize(timer.supportingTextSize);

  return (
    <Flex dir="column" gap="none" justify="center" px={px}>
      <Flex
        align="center"
        bgColor={timerBackgroundColorValue.background}
        borderColor={timerBackgroundColorValue.border}
        borderStyle="solid"
        borderWidth="1px"
        dir="column"
        grow={1}
        justify="center"
        my="lg"
        py="lg"
      >
        <Text
          fontSize={timerTextSizeValue}
          fontWeight="medium"
          textColor={timerTextColorValue}
        >
          {timer.totalTime} minutes 00 seconds
        </Text>
      </Flex>
      <Flex align="center" justify="center">
        <Text
          fontSize={supportingTextSizeValue}
          textAlign="center"
          textColor="secondary"
        >
          {timer.supportingText}
        </Text>
      </Flex>
    </Flex>
  );
};
